function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M41.11,26.57A14.92,14.92,0,1,0,56,41.48,14.92,14.92,0,0,0,41.11,26.57Zm0,26.05A11.17,11.17,0,1,1,52.28,41.45,11.17,11.17,0,0,1,41.11,52.62Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.16,50.53H14.67a3.61,3.61,0,0,1-3.62-3.61V14.65A3.61,3.61,0,0,1,14.67,11H41.53a3.6,3.6,0,0,1,3.61,3.61v7.52a1.76,1.76,0,0,0,3.52,0h0V14.65a7.13,7.13,0,0,0-7.13-7.13H14.67A7.16,7.16,0,0,0,7.5,14.65c0,8.07,0,32.27,0,32.27a7.17,7.17,0,0,0,7.17,7.13h7.49a1.76,1.76,0,0,0,0-3.52Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.56,18.92a1.43,1.43,0,0,0-1.44-1.44H17.5a1.43,1.43,0,0,0-1.43,1.44h0a1.43,1.43,0,0,0,1.43,1.43H36.12A1.43,1.43,0,0,0,37.56,18.92Zm-8.89,7.65a1.43,1.43,0,0,0-1.43-1.43H17.47A1.43,1.43,0,0,0,16,26.57h0A1.43,1.43,0,0,0,17.47,28h9.77a1.43,1.43,0,0,0,1.43-1.43ZM17.5,32.66a1.43,1.43,0,1,0,0,2.86H22a1.43,1.43,0,1,0,0-2.86ZM41.11,43.31a1.7,1.7,0,0,0,1.69-1.7V34.84a1.7,1.7,0,0,0-3.39,0h0v6.87a1.71,1.71,0,0,0,1.7,1.6Zm0,1.95a2,2,0,0,0-2,2,2.05,2.05,0,1,0,2.08-2Z"
});

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "03_\u5F02\u5E38\u6570") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e2f8c3b4.svg";
export { ForwardRef as ReactComponent };